<template>
    <div :class="{ 'be-loading': true, 'be-loading-active': active }">
        <slot/>
        <be-spinner/>
    </div>
</template>

<script>
    import BeSpinner from './BeSpinner';

    export default {
        components: { BeSpinner },

        props: {
            active: Boolean,
        },

        watch: {
            active(active) {
                if (active) {
                    window.blur();
                }
            },
        },
    };
</script>
